/*
 * ring-studio-cta.js
 * ----------------------------------------------------------------------------
 * Tema: Mercante di Pietre (Dawn 15.4.1)
 * Scopo: aggiornare dinamicamente l'href del CTA "Personalizza con il tuo
 *        diamante" sul template product.ring-studio quando l'utente cambia
 *        metallo o forma pietra nel variant picker di Dawn.
 *
 * Logica:
 *  1. Trova il bottone CTA tramite l'attributo data-base-url
 *  2. Trova il form prodotto e l'input nascosto name="id" (variant.id corrente)
 *  3. Su ogni cambio variante, ricompone l'href = base_url + "&variant=" + id
 *  4. Resiliente: ascolta più eventi/segnali in parallelo (change form,
 *     eventi custom Dawn, MutationObserver) per coprire varianti del tema
 *
 * Caricamento: il file vive in assets/ring-studio-cta.js e viene incluso dal
 *              template product.ring-studio.json via custom_liquid block.
 * ----------------------------------------------------------------------------
 */

(function () {
  'use strict';

  function init() {
    // 1) Trova il bottone CTA nella pagina (uno solo per template Ring-Studio)
    const cta = document.querySelector('a[data-base-url]');
    if (!cta) {
      // Se non c'è CTA, esce in silenzio (template diverso, niente da fare)
      return;
    }

    const baseUrl = cta.getAttribute('data-base-url');
    if (!baseUrl) return;

    // 2) Trova il form prodotto Dawn (supporta sia <product-form> che fallback)
    const productForm = document.querySelector(
      'product-form form, form[action*="/cart/add"]'
    );
    if (!productForm) {
      // Nessun form trovato: il link funziona già con la variante default
      // renderizzata server-side da Liquid. Esce in silenzio.
      return;
    }

    // 3) Trova l'input nascosto che contiene il variant.id corrente
    const variantInput = productForm.querySelector('input[name="id"]');
    if (!variantInput) return;

    // 4) Funzione di update: legge variant.id corrente e aggiorna href del CTA
    function updateCtaHref() {
      const variantId = variantInput.value;
      if (variantId && variantId.trim() !== '') {
        cta.href = baseUrl + '&variant=' + variantId;
      }
    }

    // Esecuzione immediata (allinea l'href alla variante iniziale)
    updateCtaHref();

    // 5) Strategie multiple di ascolto per robustezza cross-version Dawn:

    // 5a) Evento standard 'change' sul form (cattura cambi via radio/select)
    productForm.addEventListener('change', updateCtaHref);

    // 5b) Eventi custom Dawn/Shopify (nomi che variano tra versioni di tema)
    document.addEventListener('variant:change', updateCtaHref);
    document.addEventListener('on:variant:change', updateCtaHref);

    // 5c) MutationObserver: cattura cambi programmatici al value dell'input
    //     (utile se Dawn aggiorna l'input via JS senza emettere 'change')
    const observer = new MutationObserver(updateCtaHref);
    observer.observe(variantInput, {
      attributes: true,
      attributeFilter: ['value']
    });
  }

  // Avvio: funziona sia se il DOM è già pronto sia se è ancora in caricamento
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
